<template>
  <v-card>
    <v-card-title class="d-flex justify-center">{{ mode }}</v-card-title>
    <div style="max-height: 80vh; overflow-y: auto; scrollbar-width: unset">
      <v-form
        @submit.prevent="submitForm"
        class="mx-4 my-1"
        ref="form"
        v-model="valid"
      >
        <v-alert
          dense
          v-if="error"
          color="red"
          elevation="5"
          outlined
          text
          type="error"
          align="center"
          class="mx-1"
        >
          {{ alertValidate }}</v-alert
        >
        <div v-for="field in sortedFields" :key="field.name">
          <component
            :is="getComponentName(field.type)"
            :name="field.name"
            v-model="field.data"
            @change="handleChange(field)"
            v-if="field.show"
            :type="field.typeInput"
            :label="field.label"
            :disabled="field.disabled"
            :value="field.data"
            :rules="field.rules"
            outlined
            dense
            :items="field.items"
            :item-text="field.itemText || 'text'"
            :item-value="field.itemValue || 'id'"
            :multiple="field.multiple"
            :v-mask="field.vMask"
          />
        </div>
        <v-col v-if="showVMask" class="pa-0 ma-0">
          <v-text-field
            ref="timeField"
            class=""
            v-model="hours"
            :label="$tc('CurrentAccounts.quantityLabel')"
            outlined
            :placeholder="timePlaceholder"
            :v-mask="timeMask"
            :rules="[validateTime]"
            dense
            @keypress="allowOnlyNumbers"
          />
        </v-col>
        <v-col cols="12" class="desing-only-date-start">
          <span class="mr-1 my-auto text-caption">{{
            $tc("CurrentAccounts.dateLiq")
          }}</span>

          <div class="only-date-start">
            <v-icon @click="changeDateBy('yesterday')" class="mr-1">
              fa-angle-left
            </v-icon>
            <input
              class="inputDate"
              type="date"
              :value="dateLiq"
              @input="timerChangeDate($event, 'dateLiq')"
            />
            <v-icon @click="changeDateBy('laterday')" class="ml-1">
              fa-angle-right
            </v-icon>
          </div>
        </v-col>
        <div class="d-flex justify-space-between">
          <v-btn class="bt-exit mb-4" @click="cancel">{{
            $tc("editRegistrations.cancel")
          }}</v-btn>
          <v-btn type="submit" class="bt-acept">
            {{ $tc("editRegistrations.acept") }}</v-btn
          >
        </div>
      </v-form>
    </div>
  </v-card>
</template>

<script>
import moment from "moment";
import currentAccounts from "@/store/currentAccounts/currentAccounts";
import Vue from "vue";
import "vuetify/dist/vuetify.min.css";
import { VSelect, VTextField } from "vuetify/lib";
import VueTheMask from "vue-the-mask";

Vue.use(VueTheMask);

Vue.component("v-select", VSelect);
Vue.component("v-text-field", VTextField);

export default {
  props: {
    allFields: Array,
    show: {
      type: Boolean,
      default: false,
    },
    mode: String,
    showVMask: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: {},
      valid: true,
      error: false,
      alertValidate: "",
      debounceTimer: null,
      defaultDate: moment.utc().format("YYYY-MM-DD"),
      timeMask: "#:##",
      timePlaceholder: "0:00",
    };
  },
  mounted() {
    this.items = Vue.observable(this.allFields);
    if (currentAccounts.state.dateLiq === null) {
      this.dateLiq = this.defaultDate;
    }
  },
  computed: {
    sortedFields() {
      return this.items.slice().sort((a, b) => a.order - b.order);
    },
    hours: {
      get() {
        return currentAccounts.state.hours;
      },
      set(newValue) {
        this.setHours(newValue);
      },
    },
    dateLiq: {
      get() {
        return currentAccounts.state.dateLiq;
      },
      set(newValue) {
        this.setIDateLiq(newValue);
      },
    },
  },
  watch: {
    allFields: {
      immediate: true,
      handler(value) {
        this.items = value;
      },
    },
    hours(value) {
      if (value.length === 1 && !value.includes(":")) {
        this.timeMask = "#:##";
        this.timePlaceholder = "0:00";
      } else if (value.length === 2 && !value.includes(":")) {
        this.timeMask = "##:##";
        this.timePlaceholder = "00:00";
      } else if (value.length > 2 && !value.includes(":")) {
        this.timeMask = "###:##";
        this.timePlaceholder = "000:00";
      }

      if (this.validateTime(value) === true) {
        this.$refs.timeField.resetValidation();
      }
    },
  },
  methods: {
    allowOnlyNumbers(event) {
      const charCode = event.key.charCodeAt(0);
      if (
        (charCode < 48 || charCode > 57) && // No es un dígito 0-9
        charCode !== 58 // No es el carácter ":"
      ) {
        event.preventDefault();
      }
    },

    validateTime(value) {
      const regex = /^(\d{1,3}):([0-5][0-9])$/;
      const expectedFormat =
        this.timeMask === "#:##"
          ? "0:00"
          : this.timeMask === "##:##"
          ? "00:00"
          : "000:00";

      if (regex.test(value)) {
        const [hours, minutes] = value.split(":").map(Number);
        return (
          hours > 0 ||
          minutes > 0 ||
          `El tiempo debe ser al menos "0:01" (${expectedFormat})`
        );
      } else {
        return `Formato de hora inválido (${expectedFormat})`;
      }
    },

    setHours(hours) {
      currentAccounts.commit("setHours", hours);
    },

    setIDateLiq(date) {
      currentAccounts.commit("setDateLiq", date);
    },

    changeDate(event, model) {
      this[model] = event.target.value;
    },

    timerChangeDate(event, model) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.changeDate(event, model);
      }, 1800);
    },

    changeDateBy(action) {
      const actual = this.dateLiq || moment.utc().format("YYYY-MM-DD");

      if (moment.utc(actual, "YYYY-MM-DD", true).isValid()) {
        this.dateLiq =
          action === "yesterday"
            ? moment.utc(actual).format("YYYY-MM-DD")
            : moment.utc(actual).format("YYYY-MM-DD");
      } else {
        console.warn("La fecha actual no es válida:", actual);
      }
    },

    getComponentName(type) {
      if (type === "select") {
        return "v-select";
      } else if (type === "text") {
        return "v-text-field";
      }
    },

    submitForm(e) {
      if (e) {
        e.preventDefault();
      }
      const form = this.$refs.form.$el;
      this.validation(form);
    },

    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};

      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }
      this.$refs.form.resetValidation();
      this.$emit("save", itemsComplete);
    },

    cancel() {
      this.$refs.form.resetValidation();
      this.$emit("cancel", false);
    },

    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit(form);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },

    handleChange(item) {
      this.$emit("itemUpdate", item);
    },
  },
};
</script>
<style scoped>
.desing-only-date-start {
  margin-bottom: 28px;
  background-color: transparent;
  border-radius: 3px;
  border: 1px solid rgb(126, 126, 126);
  display: inline-flex;
  justify-content: space-between;
  padding: 8px;
}
.only-date-start {
  display: flex;
  align-items: center;
  max-height: 40px;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
